import { AxiosResponse } from 'axios';

import { InitPurchasesResponse, PurchasesSignResponse } from './dto/Purchases';
import BaseApi from './BaseApi';
import { SalesResponse } from './dto/Sales';

const purchasesApi = {
  initPurchase(
    token: string,
    payload: {
      accountId?: number;
      amount?: number;
      companyId?: number;
      tokenCount?: number;
      tokenName?: string;
      personal?: boolean;
    }
  ): Promise<AxiosResponse<InitPurchasesResponse>> {
    return BaseApi.post('/api/v1/purchases', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getPurchaseAgreement(
    token: string,
    payload: {
      id: number;
      accountId: number;
      type: 'AGREEMENT' | 'COUNTER_APPLICATION' | 'PAYMENT_CONFIRMATION';
      signed: boolean;
    }
  ): Promise<AxiosResponse<ArrayBuffer>> {
    return BaseApi.get(
      `/api/v1/purchases/${payload.id}/agreement?signed=${payload.signed}&accountId=${payload.accountId}&type=${payload.type}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'arraybuffer',
      }
    );
  },

  signHold(
    token: string,
    payload: {
      operationId: number;
    }
  ): Promise<AxiosResponse<any>> {
    return BaseApi.post(`/api/v1/purchases/hold/init`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  signHoldPublish(
    token: string,
    payload: {
      operationId: number;
      data: string;
      publicKey: string;
    }
  ): Promise<AxiosResponse<SalesResponse>> {
    return BaseApi.post(`/api/v1/purchases/hold/transaction/send`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  paymentConfirm(
    token: string,
    payload: {
      id: number;
      signature: string;
      payload: { from: number; to: number; value: number; key: string };
    }
  ): Promise<AxiosResponse<any>> {
    return BaseApi.post(
      `/api/v1/purchases/accept/init?id=${payload.id}`,
      {
        signature: payload.signature,
        payload: payload.payload,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  paymentConfirmPublish(
    token: string,
    payload: {
      operationId: number;
      data: string;
      publicKey: string;
    }
  ): Promise<AxiosResponse<SalesResponse>> {
    return BaseApi.post(`/api/v1/purchases/accept/transaction/send`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  signPurchase(
    token: string,
    payload: {
      hash: string;
      checksum: string;
      signature: string;
      accountId: number;
      operationId: number;
    }
  ): Promise<AxiosResponse<PurchasesSignResponse>> {
    return BaseApi.post(`/api/v1/purchases/sign`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getLastPurchases(
    token: string,
    payload: {
      accountId: number;
    }
  ): Promise<AxiosResponse<any>> {
    return BaseApi.get(
      `/api/v1/purchases/last/inprogress?accountId=${payload.accountId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getPurchase(
    token: string,
    payload: {
      accountId: number;
      id: number;
    }
  ): Promise<AxiosResponse<any>> {
    return BaseApi.get(
      `/api/v1/purchases/${payload.id}?accountId=${payload.accountId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getPurchasesOperator(token: string): Promise<AxiosResponse<any>> {
    return BaseApi.get(`/api/v1/purchases/operator/account`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getPurchasesOperatorCompany(token: string): Promise<AxiosResponse<any>> {
    return BaseApi.get(`/api/v1/common/info/operator`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  rejectPurchase(
    token: string,
    payload: {
      hash: string;
      checksum: string;
      signature: string;
      accountId: number;
      operationId: number;
    }
  ): Promise<AxiosResponse<any>> {
    return BaseApi.post(`/api/v1/purchases/reject`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  paymentUpload(
    token: string,
    payload: {
      id: number;
      file: Blob;
    }
  ): Promise<AxiosResponse<any>> {
    const formData = new FormData();
    formData.append('document', payload.file);

    return BaseApi.post(
      `/api/v1/purchases/payment/upload?id=${payload.id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  },
};

export default purchasesApi;
